import { atom, selector, selectorFamily } from "recoil";
import {
  finderSpecialityByName,
  finderTipoExamenByName,
} from "src/shared/global/helpers";
import CovenantsService from "../../../../services/agenda/covenants";
import SpecialityService from "../../../../services/agenda/specialities";
import TipoExamenService from "../../../../services/agenda/tipoExamen";
import ExamenService from "../../../../services/agenda/examen";
import SucursalService from "../../../../services/agenda/sucursal";
import SucursalImagenologiaService from "../../../../services/agenda/sucursalImagenologia";
import ProcedimientoService from "../../../../services/agenda/procedimientos";
import ModalidadService from "src/services/agenda/modalidad";
import getConfig from "src/config/appConfig";

export const specialitiesState = atom({
  key: "specialities",
  default: [],
});

export const specialitiesFetchState = selectorFamily({
  key: "specialitiesFetch",
  get: (modalidad) => async () => {
    // const { data } = await SpecialityService.getAll(modalidad);
    const { data } = await SpecialityService.getBySueCorrel(modalidad);
    return data.data || [];
  },
});

export const specialitiesByServiceFetchState = selectorFamily({
  key: "specialitiesByServiceFetch",
  get:
    ({ serviceCode, modalidad, sueCorrel }) =>
    async () => {
      // const { data } = await SpecialityService.getByService(
      //   serviceCode,
      //   modalidad,
      // );
      const { data } = await SpecialityService.getBySueCorrel(
        modalidad,
        sueCorrel,
      );
      return data.data;
    },
});

export const professionalsState = atom({
  key: "professionals",
  default: [],
});

export const professionalsFetchState = selectorFamily({
  key: "professionalsFetch",
  get:
    ({ codSpeciality, modalidad }) =>
    async () => {
      const { data } = await SpecialityService.getProfessionals(
        codSpeciality,
        modalidad,
      );
      return data.data;
    },
});

export const professionalsByServiceFetchState = selectorFamily({
  key: "professionalsFetch",
  get: (queryParameters) => async () => {
    const { data } = await SpecialityService.getProfessionalsByService(
      queryParameters.codSpeciality,
      queryParameters.sucursalCode,
      queryParameters.modalidad,
    );
    return data.data;
  },
});

export const professionalsBySpecialityState = selectorFamily({
  key: "professionalsBySpeciality",
  get:
    ({ specialityName, modalidad }) =>
    async ({ get }) => {
      const specialities = get(specialitiesFetchState(modalidad));
      const findSpeciality = finderSpecialityByName(
        specialities,
        specialityName,
      );
      const getProfessionals = get(
        professionalsFetchState({
          codSpeciality: findSpeciality?.esCodigo || "0",
          modalidad,
        }),
      );

      return getProfessionals;
    },
});

export const covenantsState = atom({
  key: "covenants",
  default: [],
});

export const covenantsFetchState = selector({
  key: "covenantsFetch",
  get: async () => {
    const { data } = await CovenantsService.getAll();
    return data.data;
  },
});

export const isChangeCovenantFilterState = atom({
  key: "isChangeCovenantFilter",
  default: false,
});

export const tipoExamenState = atom({
  key: "tipoExamen",
  default: [],
});

export const tipoExamenesFetchState = selector({
  key: "tipoExamenesFetch",
  get: async () => {
    const { data } = await TipoExamenService.getAll();
    return data.data;
  },
});

export const ExamenByTipoExamenState = selectorFamily({
  key: "ExamenByTipoExamenState",
  get:
    (codTipoExamen) =>
    async ({ get }) => {
      const getExamenes = get(examenesFetchState(codTipoExamen || "0"));

      // if (!specialityName || specialityName === '') {
      //     return getProfessionals;
      // }
      return getExamenes;
      //return getProfessionals.filter(el => el.especialidades.includes(specialityName));
    },
});

export const examenState = atom({
  key: "examen",
  default: [],
});

export const examenesFetchState = selectorFamily({
  key: "examenesFetch",
  get: (codigo) => async () => {
    const { data } = await ExamenService.getExamenes(codigo);
    return data.data;
  },
});

export const sucursalesState = atom({
  key: "sucursales",
  default: [],
});

export const sucursalesImagenologiaState = atom({
  key: "sucursalesImagenologia",
  default: [],
});

export const sucursalesProcedimientoState = atom({
  key: "sucursalesProcedimiento",
  default: [],
});

export const sucursalesFetchState = selector({
  key: "sucursalesFetch",
  get: async () => {
    const { SUCURSAL } = getConfig();

    const { data } = await SucursalService.getBySueCorrel(SUCURSAL);
    return data.data || [];
  },
});

export const sucursalesImagenologiaFetchState = selector({
  key: "sucursalesImagenologiaFetch",
  get: async () => {
    // const { data } = await SucursalImagenologiaService.getAll();
    const { SUCURSAL } = getConfig();

    const { data } = await SucursalService.getBySueCorrel(SUCURSAL, 2);
    return data.data || [];
  },
});

export const sucursalesProcedimientoFetchState = selector({
  key: "sucursalesProcedimientoFetch",
  get: async () => {
    // const { data } = await SucursalImagenologiaService.getAll();
    const { SUCURSAL } = getConfig();

    const { data } = await SucursalService.getBySueCorrel(SUCURSAL, null);
    return data.data || [];
  },
});

export const specialitiesByServiceState = selectorFamily({
  key: "specialitiesByService",
  get:
    ({ serviceCode, modalidad, sueCorrel }) =>
    async ({ get }) => {
      const getSpecialities = get(
        specialitiesByServiceFetchState({ serviceCode, modalidad, sueCorrel }),
      );

      return getSpecialities;
    },
});

export const professionalsByServiceState = selectorFamily({
  key: "professionalsByService",
  get:
    (queryParameters) =>
    async ({ get }) => {
      //const specialities = get(specialitiesFetchState)
      // const findSpeciality = finderSpecialityByName(specialities, specialityName)

      // let obj = {
      //     codSpeciality: "0",
      //     sucursalCode: sucursalCode
      //   };

      const getProfessionals = get(
        professionalsByServiceFetchState(queryParameters),
      );

      // if (!specialityName || specialityName === '') {
      //     return getProfessionals;
      // }
      return getProfessionals;
      //return getProfessionals.filter(el => el.especialidades.includes(specialityName));
    },
});

// ---------------- PROCEDIMIENTO ----------------
export const serviciosState = atom({
  key: "servicios",
  default: [],
});

export const serviciosFetchState = selector({
  key: "servicioFetch",
  get: (sue_correl) => async () => {
    const { data } = await ProcedimientoService.getServicios(sue_correl);

    return data.data;
  },
});

export const procedimientosState = atom({
  key: "procedimientos",
  default: [],
});

export const procedimientosFetchState = selector({
  key: "procedimientoFetch",
  get: async () => {
    const { data } = await ProcedimientoService.getServicios();
    return data.data;
  },
});

export const procedimientosByServiceFetchState = selectorFamily({
  key: "procedimientosByServiceFetch",
  get:
    ({ codService, sue_correl }) =>
    async () => {
      const { data } = await ProcedimientoService.getProcedimientos(
        codService,
        sue_correl,
      );
      return data.data;
    },
});

export const procedimientoByServiceState = selectorFamily({
  key: "procedimientoByService",
  get:
    ({ serviceCode, sue_correl }) =>
    async ({ get }) => {
      const getProcedimientos = get(
        procedimientosByServiceFetchState({
          codService: serviceCode,
          sue_correl,
        }),
      );

      return getProcedimientos;
    },
});

export const examenProcedimientosByServiceFetchState = selectorFamily({
  key: "examenProcedimientosByServiceFetch",
  get:
    ({ codService, sue_correl }) =>
    async () => {
      const { data } = await ProcedimientoService.getExamenesProcedimientos(
        codService,
        sue_correl,
      );
      return data.data;
    },
});

export const examenProcedimientoByServiceState = selectorFamily({
  key: "examenProcedimientoByService",
  get:
    ({ serviceCode, sue_correl }) =>
    async ({ get }) => {
      const getExamenProcedimientos = get(
        examenProcedimientosByServiceFetchState({
          codService: serviceCode,
          sue_correl,
        }),
      );

      return getExamenProcedimientos;
    },
});

export const modalidadesState = atom({
  key: "modalidades",
  default: [],
});

export const modalidadesFetchState = selector({
  key: "modalidadesFetch",
  get: async () => {
    const { data } = await ModalidadService.getAll();
    return data.data;
  },
});
